module.exports = __webpack_public_path__ + "img/image_charactor.8906e240.png";